import React from 'react'
import { Tooltip } from '@mui/material'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import Button from '../Button'
import { downloadPDF } from './PDFDocument'

export const PDFButton = ({disabled=false, pdfRef={}, pdfName=''}) => {
    return <Tooltip title="Download PDF" placement="bottom">
        <Button variant='contained'
            disabled={disabled}
            style={{ display: 'flex', gap: '15px', backgroundColor: '#e4e4e7', marginTop: '12px', marginLeft: '12px' }}
            onClick={() => downloadPDF(pdfRef, pdfName)}
        >
            <Tooltip title="Download PDF" placement="bottom">
                <CloudDownloadIcon />
            </Tooltip>
        </Button>
    </Tooltip>
}